/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxEarnSubscriptionsGetEarnActionListStatus = typeof UtxEarnSubscriptionsGetEarnActionListStatus[keyof typeof UtxEarnSubscriptionsGetEarnActionListStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxEarnSubscriptionsGetEarnActionListStatus = {
  active: 'active',
  inactive: 'inactive',
  success: 'success',
  cancelled: 'cancelled',
} as const;
